import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/snedson-site-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-7b979d59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-header__header-content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "main-header__logo",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "main-header__right-content" }

import SocialNetworks from "@/components/social-networks/social-networks.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'main-header',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SocialNetworks, { class: "main-header__sns" })
    ])
  ]))
}
}

})